jQuery( window ).on("load", function() {
    // jQuery('.announcement_slider .announcement_slide').css("display", "none");
      // jQuery('.announcement_slider .announcement_slide').css("opacity", "1");
    setTimeout(function () {
    }, 200);
});
jQuery(document).ready(function() {
  jQuery(".review-content .review-desc").each(function() {
    var content = jQuery(this).find('span').text();
    jQuery(this).attr('content-size',content.length);

    if(content.length > 270){
      jQuery(this).addClass('overflow_content');
    }
  });
  
  var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
  var hash = hashes[0].split('=');

  if(hash[1] == "true"){
    jQuery(".offer-wr .af-form-wrapper #mce-success-response").show();
    jQuery(".offer-wr .af-form-wrapper #af-form-477944189").hide();
  }
  
  var window_size = screen.width;

  if(window_size <= 649){
    jQuery('.collection_products_slider').bxSlider({
  	  auto: true,
      touchEnabled: false,
  	  controls: true,
  	  pager: false,
      slideWidth: 345,
      maxSlides: 1,
  	  moveSlides: 1
    });
  }
  
  if(window_size <= 767){
    jQuery('.humble_beginnings_wr.desktop').hide();
    jQuery('.humble_beginnings_wr.mobile').show();
    
    jQuery('.collection_slider').bxSlider({
  	  auto: true,
      touchEnabled: false,
  	  controls: true,
  	  pager: false,
      slideWidth: 250,
      slideMargin: 20,
      maxSlides: 1,
  	  moveSlides: 1
    });
    
    review_slider_width = 340;
    review_slider_margin = 0;
    review_slide_max_slide = 1;
    var review_slide_move_slide = 1;
    
    var announcement_slider_width = 300;

    var popup_video_width = 300;
    var popup_video_margin = 0;
    var popup_video_max_slide = 1;
  }
  else if(window_size <= 979){
    jQuery('.collection_slider').bxSlider({
  	  auto: true,
      touchEnabled: false,
  	  controls: true,
  	  pager: false,
      slideWidth: 230,
      slideMargin: 21,
      maxSlides: 3,
  	  moveSlides: 1
    });

    review_slider_width = 300;
    review_slider_margin = 25;
    review_slide_max_slide = 2;
    var review_slide_move_slide = 2;
    
    var announcement_slider_width = 600;

    var popup_video_width = 300;
    var popup_video_margin = 20;
    var popup_video_max_slide = 2;
  }
  else if(window_size <= 1023){
    jQuery('.collection_slider').bxSlider({
  	  auto: true,
      touchEnabled: false,
  	  controls: true,
  	  pager: false,
      slideWidth: 300,
      slideMargin: 21,
      maxSlides: 3,
  	  moveSlides: 1
    });

    review_slider_width = 365;
    review_slider_margin = 25;
    review_slide_max_slide = 2;
    var review_slide_move_slide = 2;

    var announcement_slider_width = 800;

    var popup_video_width = 300;
    var popup_video_margin = 15;
    var popup_video_max_slide = 3;
  }
  else if(window_size <= 1199){
    jQuery('.collection_slider').bxSlider({
  	  auto: true,
      touchEnabled: false,
  	  controls: true,
  	  pager: false,
      slideWidth: 314,
      slideMargin: 21,
      maxSlides: 3,
  	  moveSlides: 1
    });
    review_slider_width = 365;
    review_slider_margin = 25;
    review_slide_max_slide = 2;
    var review_slide_move_slide = 2;

    var announcement_slider_width = 800;

    var popup_video_width = 300;
    var popup_video_margin = 20;
    var popup_video_max_slide = 3;
  }
  else if(window_size <= 1365){
    jQuery('.collection_slider').bxSlider({
  	  auto: true,
      touchEnabled: false,
  	  controls: true,
  	  pager: false,
      slideWidth: 374,
      slideMargin: 25,
      maxSlides: 3,
  	  moveSlides: 1
    });
    
    review_slider_width = 365;
    review_slider_margin = 25;
    review_slide_max_slide = 3;
    var review_slide_move_slide = 3;

    var announcement_slider_width = 800;

    var popup_video_width = 300;
    var popup_video_margin = 30;
    var popup_video_max_slide = 3;
  }
  else if(window_size <= 1679){
    jQuery('.collection_slider').bxSlider({
  	  auto: true,
      touchEnabled: false,
  	  controls: true,
  	  pager: false,
      slideWidth: 374,
      slideMargin: 25,
      maxSlides: 3,
  	  moveSlides: 1
    });
    
    review_slider_width = 365;
    review_slider_margin = 25;
    review_slide_max_slide = 3;
    var review_slide_move_slide = 3;

    var announcement_slider_width = 800;

    var popup_video_width = 300;
    var popup_video_margin = 30;
    var popup_video_max_slide = 4;
  }
  else{
    jQuery('.collection_slider').bxSlider({
  	  auto: true,
      touchEnabled: false,
  	  controls: true,
  	  pager: false,
      slideWidth: 374,
      slideMargin: 24,
      maxSlides: 4,
  	  moveSlides: 1
    });

    var announcement_slider_width = 600;

    review_slider_width = 435;
    review_slider_margin = 40;
    review_slide_max_slide = 3;
    var review_slide_move_slide = 3;

    var popup_video_width = 332;
    var popup_video_margin = 30;
    var popup_video_max_slide = 5;
  }

  jQuery('.review-slider').bxSlider({
  	  auto: false,
      touchEnabled: false,
  	  controls: true,
  	  pager: true,
      adaptiveHeight: false,
      slideWidth: review_slider_width,
      slideMargin: review_slider_margin,
      maxSlides: review_slide_max_slide,
  	  moveSlides: review_slide_move_slide
  });

  // jQuery('.announcement_slider').bxSlider({
  // 	  auto: true,
  //     pause: 5000,
  //     touchEnabled: false,
  // 	  controls: true,
  //     infiniteLoop: true,
  // 	  pager: false,
  //     adaptiveHeight: true,
  //     slideWidth:announcement_slider_width,
  //     maxSlides: 1,
  // 	  moveSlides: 1,
  // });

// Video Slider

  // var videosliderproduct = 350;
  jQuery('.popup_videos_slider').bxSlider({
  	  auto: false,
      pause: 2000,
      touchEnabled: false,
  	  controls: true,
      infiniteLoop: true,
  	  pager: false,
      adaptiveHeight: true,
      slideWidth: popup_video_width,
      slideMargin: popup_video_margin,
      maxSlides: popup_video_max_slide,
  	  moveSlides: 1,
  });

  
  
  setTimeout(function() {
    jQuery('.overlay').fadeIn();
    jQuery('.popup.offer-form').fadeIn();
    jQuery('.offer-button').fadeOut();
  }, 3000);

  jQuery(".overlay").on("click", function(){
    jQuery(this).fadeOut();
    jQuery('.popup.offer-form').fadeOut();
    jQuery('.offer-button').fadeIn();
  });

  jQuery(".offer-button").on("click", function(){
    jQuery('.overlay').fadeIn();
    jQuery('.popup.offer-form').fadeIn();
    jQuery(this).fadeOut();
  });

  jQuery(".form-overlay,.successForm.feedback a").on("click", function(){
    jQuery('.form-overlay').fadeOut();
    jQuery('.successForm.feedback').fadeOut();
  });

  jQuery('body').on('click','.videos_popup_block .play_btn',function(){
        var video_url = jQuery(this).attr('video-url');
        jQuery('.video-popup video').attr('src',video_url);
        jQuery('.popup_overlay').fadeIn(500);
        jQuery('.video-popup-wr').fadeIn(500);
    });

    jQuery('body').on('click','.popup_overlay',function(){
        jQuery('.video-popup video').attr('src',"");
        jQuery('.popup_overlay').fadeOut(500);
        jQuery('.video-popup-wr').fadeOut(500);
    });

    jQuery('body').on('click','.video-popup-wr .close',function(){
        jQuery('.video-popup video').attr('src',"");
        jQuery('.popup_overlay').fadeOut(500);
        jQuery('.video-popup-wr').fadeOut(500);
    });

    $('.product-single__description-inner').children('p').not(':first-child').wrapAll('<div class="moretext" />');

    jQuery('.moreless-button').click(function(e) {
      e.preventDefault();
      jQuery('.moretext').slideToggle();
      if (jQuery('.moreless-button').text() == "Read more") {
        jQuery(this).text("Read less")
      } else {
        jQuery(this).text("Read more")
      }
    });
});

jQuery(".button").on("click", function(){
  var email = $('#mce-EMAIL').val();
  if(email != ""){
      if (jQuery('#mce-success-response:visible') ) {
          jQuery('#mc_embed_signup_scroll').hide();
          jQuery('#mce-success-response').css('margin', "0");
      }
  }
});
jQuery('.faq-content-inner-wr.first').addClass('active');
jQuery('.faq-content-inner-wr.first').find('.faq-content').slideDown();

jQuery(".faq-title h4").on("click", function(){
  if(!jQuery(this).parents('.faq-content-inner-wr').hasClass('active')){
      jQuery('.faq-content-inner-wr').removeClass('active');
      jQuery(this).parents('.faq-content-inner-wr').addClass('active');
      jQuery('.faq-content').slideUp();
      jQuery(this).siblings('.faq-content').slideDown();
  }else{
    jQuery(this).parents('.faq-content-inner-wr').removeClass('active');
    jQuery(this).siblings('.faq-content').slideUp();
  }
});

// jQuery('.product-content-inner-wr.first').addClass('active');
// jQuery('.product-content-inner-wr.first').find('.product-content').slideDown();

jQuery(".product-title h4").on("click", function(){
  if(!jQuery(this).parents('.product-content-inner-wr').hasClass('active')){
      jQuery('.product-content-inner-wr').removeClass('active');
      jQuery(this).parents('.product-content-inner-wr').addClass('active');
      jQuery('.product-content').slideUp();
      jQuery(this).siblings('.product-content').slideDown();
  }else{
    jQuery(this).parents('.product-content-inner-wr').removeClass('active');
    jQuery(this).siblings('.product-content').slideUp();
  }
});
// jQuery(window).load(function() {
//     jQuery('.announcement_slider_wr').css("overflow", "hidden");
// });

jQuery(window).scroll(function(){
      var sticky = jQuery('.site-header'),
        scroll = jQuery(window).scrollTop();
      var window_size = (screen.width);
      
        if (scroll >= 100){ 
          if(window_size > 979){
            sticky.addClass('fixed');
          }
        }
        else { 
           sticky.removeClass('fixed');
        }

      if (jQuery(this).scrollTop() > 400) {
          // console.log(jQuery(this).scrollTop());
          jQuery('.scrolltop-btn').show();
      }
      else {
          jQuery('.scrolltop-btn').hide();
      }

});


 jQuery(window).scroll(function () {

   if(jQuery(this).width() > 749) {

      var scrollTopValue = jQuery(window).scrollTop();
      
      var announcementBarheight = jQuery('.announcement_slider_blk').outerHeight();
      var headHeight = jQuery('#shopify-section-header').outerHeight();
      var finalHeight = Number(announcementBarheight) + Number(headHeight); 
      
      var mediaBlk = jQuery('.blk-product-media').outerHeight(); // moving part
      
      var productBlk = jQuery('.blk-product-info').outerHeight(); // fix content
      
      
      var remaingHeight = Number(productBlk) - Number(mediaBlk);
      
      
      var partyFormOffset = jQuery('.blk-product-info').offset();
      var mainPartyFormOffset = partyFormOffset.top;
      var footeroffset = jQuery('.product-collection-blk').offset();
      var mainfooterOffset = footeroffset.top;
      
      if(scrollTopValue > mainfooterOffset) {
      
      } else if(scrollTopValue > mainPartyFormOffset) {
        var flotingscrollTop = Number(scrollTopValue) - Number(finalHeight);
        flotingscrollTop = flotingscrollTop - 100;
        if(flotingscrollTop <= remaingHeight) {
          jQuery('.blk-product-media').css('transform','translateY('+flotingscrollTop+'px)');
        }
      } else {
        jQuery('.blk-product-media').css('transform','translateY(19px)');
      }
   }

});
  